import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../../../../packages/components';
import Device from '../../../../../devices/device';
import { setInitialFocus } from '../../../../../utils/Utils';
import Metadata from '../../../../../requests/apa/Metadata';
import Translations from '../../../../../requests/apa/Translator';
import './_MatchDetailTabs.scss';


class MatchDetailTabs extends Component {
  constructor(props) {
    super(props);
    this.keys = Device.getDevice().getKeys();
    this.state = { containerFocused: false };
  }

  getheaderMatchData() {
        return [
                { id: 'stats', label: Translations.get('eventodeportivo_partidos_tabs_texto_tab1')}, 
                { id: 'players', label: Translations.get('eventodeportivo_partidos_tabs_texto_tab2')},
                { id: 'summary', label: Translations.get('eventodeportivo_partidos_tabs_texto_tab3')},
                { id: 'lineups', label: Translations.get('eventodeportivo_partidos_tabs_texto_tab4')}
              ];
  }

  componentDidMount() {
    setTimeout(() => {
      const firstTab = document.querySelector('.match-detail-tabs .focusable');
      if (firstTab && firstTab.id) {
        setInitialFocus(`#${firstTab.id}`, false);
      }
    }, 300);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeTab !== this.props.activeTab) {
      setTimeout(() => {
        if (this.props.activeTab === 'players') {
          const hasArgTeamButton = document.querySelector('#match-detail-team-arg');
          const teamTargetSelector = hasArgTeamButton ? '#match-detail-team-arg' : '.match-detail-players-switch .focusable';
          const teamTarget = document.querySelector(teamTargetSelector);

          if (teamTarget) {
            if (window.SpatialNavigation && typeof window.SpatialNavigation.makeFocusable === 'function') {
              window.SpatialNavigation.makeFocusable();
            }
            setInitialFocus(teamTargetSelector, false);
            return;
          }
        }

        const targetId = `match-detail-tab-${this.props.activeTab}`;
        setInitialFocus(`#${targetId}`, false);
      }, 0);
    }
  }

  onKeyDown = (e) => {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
    if (!currentKey || !['LEFT', 'RIGHT', 'UP', 'DOWN'].includes(currentKey)) return;

    if (currentKey === 'DOWN') {
      const focusedElement = document && document.activeElement ? document.activeElement : null;
      const focusedId = focusedElement && focusedElement.id ? focusedElement.id : '';
      const isPlayersTabFocused = focusedId === 'match-detail-tab-players' && this.props.activeTab === 'players';
      const isSummaryTabFocused = focusedId === 'match-detail-tab-summary' && this.props.activeTab === 'summary';

      if (isPlayersTabFocused) {
        const hasArgTeamButton = document.querySelector('#match-detail-team-arg');
        const targetSelector = hasArgTeamButton ? '#match-detail-team-arg' : '.match-detail-players-switch .focusable';

        e.preventDefault();
        e.stopPropagation();

        if (window.SpatialNavigation && typeof window.SpatialNavigation.makeFocusable === 'function') {
          window.SpatialNavigation.makeFocusable();
        }
        const playersTarget = document.querySelector(targetSelector);
        if (playersTarget && playersTarget.focus) playersTarget.focus({ preventScroll: true });
        return;
      }

      if (isSummaryTabFocused) {
        e.preventDefault();
        e.stopPropagation();

        if (window.SpatialNavigation && typeof window.SpatialNavigation.makeFocusable === 'function') {
          window.SpatialNavigation.makeFocusable();
        }
        const summaryToggle = document.getElementById('match-detail-summary-toggle');
        if (summaryToggle) {
          var winTop = window.pageYOffset || document.documentElement.scrollTop || 0;
          summaryToggle.focus();
          window.scrollTo(0, winTop);
        }
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      if (window.SpatialNavigation && typeof window.SpatialNavigation.makeFocusable === 'function') {
        window.SpatialNavigation.makeFocusable();
      }
      const contentTarget = document.querySelector('.match-detail-body__content');
      if (contentTarget && contentTarget.focus) contentTarget.focus({ preventScroll: true });
      return;
    }
    if (currentKey === 'UP') {
      e.preventDefault();
      e.stopPropagation();
      const focusedElement = document && document.activeElement ? document.activeElement : null;
      const focusedId = focusedElement && focusedElement.id ? focusedElement.id : '';
      if (focusedId === 'match-detail-tab-summary' || focusedId === 'match-detail-tab-lineups') {
        // Si el upsell panel está visible, enfocar su primer botón focusable
        var upsellPanel = document.querySelector('.match-detail-upsell-panel')
        if (upsellPanel) {
          var contratarBtn = upsellPanel.querySelector('.match-detail-upsell-panel__contratar-btn')
          if (contratarBtn && contratarBtn.focus) {
            contratarBtn.focus({ preventScroll: true })
            return
          }
        }
        
        // Si no existe carrusel, enfocar el área de video; si existe, enfocar primer canal
        const hasCarousel = document.querySelector('.match-detail-video-panel__carousel');
        if (!hasCarousel) {
          const videoArea = document.getElementById('mdvp-video-area');
          if (videoArea && videoArea.focus) {
            videoArea.focus({ preventScroll: true });
            return;
          }
        }
        
        const firstChannel = document.querySelector('#mdvp-channel-0');
        if (firstChannel && firstChannel.focus) {
          firstChannel.focus({ preventScroll: true });
          return;
        }
      }
      const backBtn = document.querySelector('#btnMundialBack');
      if (backBtn && backBtn.focus) backBtn.focus();
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const { tabs, activeTab, onChange, onNavigate } = this.props;
    const safeTabs = tabs && tabs.length ? tabs : this.getheaderMatchData();
    const currentIndex = safeTabs.findIndex(tab => tab.id === activeTab);
    if (currentIndex === -1) return;
    if (currentKey === 'LEFT' && currentIndex === 0) return;
    if (currentKey === 'RIGHT' && currentIndex === safeTabs.length - 1) return;

    if (onNavigate) {
      if (currentKey === 'LEFT') return onNavigate(-1);
      if (currentKey === 'RIGHT') return onNavigate(1);
      return;
    }

    const delta = currentKey === 'LEFT' ? -1 : 1;
    const nextIndex = currentIndex + delta;
    const nextTab = safeTabs[nextIndex];
    if (nextTab && onChange) onChange(nextTab.id);
  };


  render() {
    const { tabs, activeTab, onChange, itemDataOptions } = this.props;
    const { containerFocused } = this.state;
    const safeTabs = tabs && tabs.length ? tabs : this.getheaderMatchData();
    const pp =  Metadata.get('eventodeportivo_partidos_tabs_texto_tab1');
     const pp2 =  Translations.get('eventodeportivo_partidos_tabs_texto_tab1');

    return (
      <div
        className="match-detail-tabs"
        onKeyDown={this.onKeyDown}
        onFocus={() => this.setState({ containerFocused: true })}
        onBlur={() => this.setState({ containerFocused: false })}
      >
        {safeTabs.map((tab) => {
          const isActive = tab.id === activeTab;
          const activeClass = isActive
            ? (containerFocused ? 'match-detail-tabs__tab--active' : 'match-detail-tabs__tab--active')
            : '';

          return (
            <Button
              key={tab.id}
              id={`match-detail-tab-${tab.id}`}
              className={`focusable match-detail-tabs__tab ${activeClass}`}
              dataOptions={itemDataOptions}
              onClick={() => onChange(tab.id)}
              onFocus={() => onChange(tab.id)}
              onKeyDown={this.onKeyDown}
            >
              {tab.label}
            </Button>
          );
        })}
      </div>
    );
  }
}

MatchDetailTabs.propTypes = {
  tabs: PropTypes.array,
  activeTab: PropTypes.string,
  onChange: PropTypes.func,
  onNavigate: PropTypes.func,
  itemDataOptions: PropTypes.object
};

// MatchDetailTabs.defaultProps = {
//   tabs: this.getheaderMatchData(),
//   activeTab: 'stats',
//   onChange: () => {},
//   onNavigate: null,
//   itemDataOptions: {}
// };

export default MatchDetailTabs;



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/Components/MatchDetailTabs/MatchDetailTabs.jsx